import React from "react";
import { t } from "ttag";

const DEFAULT_MESSAGE_LEVELS = {
    DEBUG: 10,
    INFO: 20,
    SUCCESS: 25,
    WARNING: 30,
    ERROR: 40,
};

interface IMessage {
    level: number;
    message: string;
    tags: string;
    level_tag: string;
    extra_tags: string;
}

interface IMessagesProps {
    messages: IMessage[];
}

const getMessageByType = (
    extraTags: string,
    level: number,
): React.JSX.Element => {
    if (extraTags === "added-to-cart") {
        return <>{t`Added to Cart`}</>;
    }
    let message = "";
    switch (level) {
        case DEFAULT_MESSAGE_LEVELS.DEBUG:
            message = t`Info`;
            break;
        case DEFAULT_MESSAGE_LEVELS.INFO:
            message = t`Info`;
            break;
        case DEFAULT_MESSAGE_LEVELS.SUCCESS:
            message = t`Success`;
            break;
        case DEFAULT_MESSAGE_LEVELS.WARNING:
            message = t`Warning`;
            break;
        case DEFAULT_MESSAGE_LEVELS.ERROR:
            message = t`Error`;
            break;
        default:
            message = t`Info`;
            break;
    }
    return <>{message}</>;
};

export const Messages: React.FC<IMessagesProps> = ({ messages }) => {
    return (
        <aside className="messages l-full-width">
            <ul className="messages__list">
                {messages.map((message: IMessage, i: number) => (
                    <li
                        className={`messages__item ${message.tags}`}
                        key={`key-${i}`}
                    >
                        <div className="messages__item__content l-capped-width">
                            <p>
                                <span
                                    className={`messages__item__category messages__item__category--${message.level_tag}`}
                                >
                                    {getMessageByType(
                                        message.extra_tags,
                                        message.level,
                                    )}
                                </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: message.message,
                                    }}
                                />
                            </p>
                            <button className="messages__item__close">
                                <svg
                                    className={`icon icon--reviews-no`}
                                    aria-label={`Close`}
                                    role="img"
                                >
                                    <use xlinkHref={`#reviews-no`} />
                                    <title>{`Close`}</title>
                                </svg>
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </aside>
    );
};
